import { ThemeDarkValues, ThemeLightValues } from '@picsart/design-system/foundation/colors';
import { useFoundation } from '@picsart/design-system/hooks/initFoundation';
import { getContext } from 'configs/context';
import useOpen from 'hooks/useOpen';
import { useState } from 'react';

const themes = [
  {
    key: 'light',
    value: ThemeLightValues,
    selected: false,
  },
  {
    key: 'dark',
    value: ThemeDarkValues,
    selected: false,
  },
];

const useThemeChange = () => {
  const [themeMode, setThemeMode] = useState(themes);
  useOpen(() => {
    return getContext().general.theme.subscribe(
      value => {
        setThemeMode(prevThemes =>
          prevThemes.map(theme => ({
            ...theme,
            selected: theme.key === value,
          })),
        );
      },
      { needPrevious: true },
    );
  });

  useFoundation({ themes: themeMode });
};

export default useThemeChange;
